import { CONFIG } from 'app/core/config';
import { ViewModel } from 'app/viewmodels/view-model';
import { ObjectDrawerFilterValueType } from './object-drawer-filter-value-type';

export class ObjectDrawerFilter implements ViewModel {
  friendlyTypeNameSingular: string = 'Object Drawer Filter';
  apiRoute: string = CONFIG.apiRoutes.objectDrawerFilter;

  public value: string;
  public valueType: ObjectDrawerFilterValueType;
  public propertyName: string;
  public displayName: string;
  public options: any[] = [];
  public lazyLoad: boolean;
  public lazyLoadEndpoint: string;
  public getExactMatch: boolean;
  public isFromSearchInput: boolean;

  public originalGetExactMatch: boolean;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    if (!data) {
      return;
    }

    this.value = data.value;
    this.valueType = data.valueType;
    this.propertyName = data.propertyName;
    this.displayName = data.displayName;
    this.options = data.options;
    this.lazyLoad = data.lazyLoad;
    this.lazyLoadEndpoint = data.lazyLoadEndpoint;
    this.getExactMatch = data.getExactMatch;
    this.originalGetExactMatch = data.getExactMatch;
    this.isFromSearchInput = data.isFromSearchInput;
  }

  getUserFriendlyOptions(): any[] {
    return this.options
      .map(e => ({ key: e.key, value: e.value.replace(/([A-Z])/g, ' $1').trim()}))
      .map(e => ({ key: e.key, value: e.value = e.value === 'Rbi' ? 'Risk-based Inspection' : e.value})); // This map is not ideal and would be better replaced with a change in the API but that would be a larger and riskier piece of work. If we have to do similar again make the change in the API (See #104696).
  }
}
